var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 81.141 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16851",
    "data-name": "Group 16851",
    transform: "translate(-144 -1536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32467",
    "data-name": "Path 32467",
    d: "M33.276,2A18.276,18.276,0,1,0,51.551,20.276,18.276,18.276,0,0,0,33.276,2Z",
    transform: "translate(129 1534)",
    fill: "#cdf7fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16739",
    "data-name": "Group 16739",
    transform: "translate(155.49 1545.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16733",
    "data-name": "Group 16733",
    transform: "translate(34.826 29.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32461",
    "data-name": "Path 32461",
    d: "M29.413,50.629a2.178,2.178,0,0,1-.853-.174C27.886,50.168,12,43.249,12,29.02V17.359A2.176,2.176,0,0,1,13.477,15.3l15.236-5.183a2.178,2.178,0,0,1,1.4,0L45.348,15.3a2.176,2.176,0,0,1,1.477,2.061V29.02c0,14.229-15.886,21.148-16.56,21.438a2.228,2.228,0,0,1-.853.171ZM16.353,18.918v10.1c0,9.673,10.03,15.489,13.06,17.021,3.03-1.532,13.06-7.348,13.06-17.021v-10.1l-13.06-4.443Z",
    transform: "translate(-12 -10)",
    fill: "#2a3d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16734",
    "data-name": "Group 16734",
    transform: "translate(43.533 40.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32462",
    "data-name": "Path 32462",
    d: "M22.98,29.962a2.16,2.16,0,0,1-1.538-.638l-5.8-5.8a2.177,2.177,0,0,1,3.079-3.079l4.031,4.031,7.2-9.6a2.176,2.176,0,0,1,3.48,2.615L24.719,29.094a2.174,2.174,0,0,1-1.587.865c-.049,0-.1,0-.151,0Z",
    transform: "translate(-15 -14)",
    fill: "#2a3d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16735",
    "data-name": "Group 16735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32463",
    "data-name": "Path 32463",
    d: "M30.734,60.945H7.981A7.987,7.987,0,0,1,0,52.964V7.981A7.987,7.987,0,0,1,7.981,0H41.355a7.987,7.987,0,0,1,7.981,7.981V23.739a2.177,2.177,0,1,1-4.353,0V7.981a3.633,3.633,0,0,0-3.628-3.628H7.981A3.633,3.633,0,0,0,4.353,7.981V52.964a3.633,3.633,0,0,0,3.628,3.628H30.734a2.177,2.177,0,0,1,0,4.353Z",
    fill: "#2a3d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16736",
    "data-name": "Group 16736",
    transform: "translate(8.706 23.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32464",
    "data-name": "Path 32464",
    d: "M32.747,12.353H5.177A2.177,2.177,0,1,1,5.177,8h27.57a2.177,2.177,0,0,1,0,4.353Z",
    transform: "translate(-3 -8)",
    fill: "#2a3d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16737",
    "data-name": "Group 16737",
    transform: "translate(8.706 34.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32465",
    "data-name": "Path 32465",
    d: "M21.138,16.353H5.177a2.177,2.177,0,0,1,0-4.353H21.138a2.177,2.177,0,1,1,0,4.353Z",
    transform: "translate(-3 -12)",
    fill: "#2a3d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16738",
    "data-name": "Group 16738",
    transform: "translate(8.706 11.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32466",
    "data-name": "Path 32466",
    d: "M18.236,8.353H5.177A2.177,2.177,0,1,1,5.177,4h13.06a2.177,2.177,0,1,1,0,4.353Z",
    transform: "translate(-3 -4)",
    fill: "#2a3d57"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacy);
export default __webpack_public_path__ + "static/media/DataPrivacy.49dee314a8ade6f8b01934d771e18d30.svg";
export { ForwardRef as ReactComponent };